import { AnaColumn } from "../forms-template.service";
import { gridEditable, gridSimple } from "./gridSettings/gridSettings";
//import { aspect } from "./aspect";
const aspect = 'vw';
const aspectRatio = 7.7;


export const sedeForm: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',
      breadcrumbCaption: 'Anagrafica unità locale',
      campoTitle: ['descrizioneSoggetto', 'descrizioneSede'],
      service: 'sede',
      api: 'Sede',

      allowedAdvancedFilter: true,
      isAdvancedXlsExportAvailable: true,
      advancedXlsExportFilterTemplateName: "esportaUnitaLocaliFiltri",
      filterList: '/$idSoggetto',
      filterEditor: '?id=$',
      startTemplate: 'grid',
      helpDoc: 'Unitalocale.html',
      queryFilter: [

        {
          key: 'idSede',
          value: 'id'
        },
        {
          key: 'idSoggetto',
          value: 'idSoggetto'
        },
        {
          key: 'descrizioneSede',
          value: 'descrizione'
        },
        {
          key: 'descrizioneSoggetto',
          value: 'descrizioneSoggetto'
        },
        {
          key: 'numeroIscrizioneAlbo',
          value: 'numeroIscrizioneAlbo'
        },

      ],
      idTabRif:
        [

          {
            key: 'idSoggetto',
            value: 'idSoggetto'
          },
          {
            key: 'nsAzienda',
            value: 'nsAzienda'
          },



          //Per inserire direttamente una sede che fa attività di produttore,trasportatore,intermediario,smaltitore

          {
            key: 'isProduttore',
            value: 'isProduttore'
          },
          {
            key: 'isTrasportatore',
            value: 'isTrasportatore'
          },
          {
            key: 'isSmaltitore',
            value: 'isSmaltitore'
          },
          ,
          {
            key: 'isIntermediario',
            value: 'isIntermediario'
          },


        ],
      formType: 'tabbed',
      masterKey: 'id',
      nCol: 1,
      toolbarSettings: {
        service: 'sede',
      }

    }

  },


  {
    itemType: "group", groupWidth: 850, caption: "Dati Principali U. L.", colCount: "5", class: '', groupDataField: 'datiUL', data: [

      { type: 'empty', colVisible: false, dataType: "", hideOnEdit: false, caption: "Attività svolta dall'Unità Locale", colSpan: 5 },

      {
        orderGriglia: 2,
        colSpan: 5,
        showInColumnChooser: false, allowHiding: false,
        type: 'campoMultiData',
        colWidth: '150px',
        dataField: 'tipoAttivita',
        colVisible: true,
        hideOnEdit: true,
        caption: 'Tipo attività',
        dataType: 'object',
        allowFiltering: false
      },

      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        dataField: "isProduttore",
        dataType: "boolean",
        caption: "Produttore",
        editorType: "dxCheckBox",
        colVisible: false,
        labelWidth: 97,
        nCol: 17
      },
      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        dataField: "isSmaltitore",
        dataType: "boolean",
        labelWidth: 90,
        caption: "Destinatario",
        editorType: "dxCheckBox",
        colVisible: false,
        nCol: 17,

      },
      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        dataField: "isIntermediario",
        dataType: "boolean",
        caption: "Intermediario",
        editorType: "dxCheckBox",
        colVisible: false,
        nCol: 20,
        labelWidth: 90,
        checkBox: {
          event: {
            type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
            key: 'setTrueIntermediario', //In quanto listaCarrozzerieAlboGestore
            value: [
              {
                optionName: 'isIntermediario',
                value: 'true'
              }
            ]
          },

        }
      },
      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        dataField: "isTrasportatore",
        dataType: "boolean",
        caption: "Trasp./Op.Logist.",
        editorType: "dxCheckBox",
        colVisible: false,
        nCol: 20,
        labelWidth: 125,
        checkBox: {
          event: {
            type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
            key: 'setTrueTrasportatore', //In quanto listaCarrozzerieAlboGestore
            value: [

            ]
          },
        }
      },
      {
        showInColumnChooser: false,
        type: 'campoSpecial', colVisible: false, dataField: "tipoTrasporto",
        caption: "Tipo Vettore", maxLength: "1", maxSize: 2, hideOnEdit: false,
        editorType: 'dxSelectBox',
        nCol: 3,
        labelWidth: 90,
        lista: {
          dataSource: 'TipoTrasporto',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false
        },
      },

      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "Dati iscrizione albo gestori ambientali", colSpan: '5' },

      //--------------------- DATI ISCRIZIONE ALBO ---------------------
      {
        showInColumnChooser: false,
        type: 'campo',
        nCol: 3,
        dataField: "numeroIscrizioneAlbo",
        caption: "N.Albo",
        dataType: "",
        maxLength: '14',
        maxSize: 14,
        labelWidth: 97,
        colWidth: '145',
        colVisible: false,
        validation: [{
          type: 'pattern', message: 'Il campo N.Albo deve avere il seguente formato di esempio AB/123456', value: "^\\s*([A-Za-z]{2})\\/([0-9]{6})\\s*$"
        }]
      },
      {
        showInColumnChooser: false,
        type: 'campo',
        labelWidth: 100,
        colSpan: '1',
        dataField: "protocolloAlbo",
        caption: "Protocollo",
        dataType: "",
        maxLength: '14',
        nCol: 3,
        maxSize: 14,
        colWidth: '150',
        class: "required",
        colVisible: false,


      },
      {
        showInColumnChooser: false,
        type: 'campoData',
        colSpan: '1',
        labelWidth: 100,
        nCol: 3,
        dataField: "dataIscrizioneAlbo",
        caption: "Data Iscrizione ",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        maxLength: '14',
        maxSize: 14,
        colWidth: '150',
        showClearButton: true,
        colVisible: false,
      },

      { type: 'empty', colVisible: false, dataField: "", dataType: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "" },

      //-----------------------------------------------------------------
      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: " ", colSpan: '5' },

      {
        type: 'simpleButton',
        colVisible: false,
        dataField: 'copiaDatiAzienda',
        dataType: "",
        colSpan: 5,
        caption: 'Dati sede legale',
        helpText: 'Ottieni indirizzo, comune, città, stato ecc... della sede legale',
        hideOnEdit: false,

        class: 'sedeButton',

        button: {
          text: 'Copia dati della sede legale',
          name: 'copiaDatiAzienda',
          type: 'text',
          location: 'after',
          event: "copiaDatiAzienda",
          hint: "Ottieni indirizzo, comune, città, stato ecc... della sede legale",
          icon: "glyphicon mdi mdi-checkbox-blank-outline",
          outPutValue: false,
        }

      },


      {
        orderGriglia: 2,
        type: 'campo',
        dataField: "descrizione",
        dataType: "",
        caption: "Descrizione",
        colVisible: true,
        showClearButton: false,
        maxSize: 45,
        maxLength: "45",
        nCol: 7,
        colWidth: '700',

        showInColumnChooser: false,
        validation: [
          { type: "required", message: "Descrizione obbligatoria" },

        ],
      },
      {
        type: 'campoButton',
        showInColumnChooser: false,
        colVisible: false,
        dataField: "idSedeRentri",
        dataType: "",
        nCol: 3,
        caption: "R.E.N.T.Ri",
        labelWidth: 50,
        class: 'nsAziendaTrue',
        //colSpan: '2',
        disableOnUpdate: true,
        showClearButton: false,
        button: {
          name: 'allineaRentri',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "ottieni le sedi R.E.N.T.R.i",
          icon: "glyphicon mdi mdi-playlist-plus",
          outPutValue: false,
        }
      },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },
      {
        orderGriglia: 3,
        showInColumnChooser: true, allowHiding: false,
        type: 'campo', dataField: "indirizzo", dataType: "", caption: "Indirizzo",
        colVisible: true,
        nCol: 7,
        maxSize: 35,
        maxLength: "35",
        validation: [
          { type: "required", message: "Indirizzo obbligatorio" },

        ],
      },
      {
        orderGriglia: 4, showInColumnChooser: true, allowHiding: false,
        type: 'campo', dataField: "civico", dataType: "", caption: "Civico",
        colVisible: true,
        colWidth: '70',
        labelWidth: 50,
        nCol: 2,
        maxLength: 7,
        maxSize: 7
      },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "", nCol: 1 },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },

      {
        orderGriglia: 5,
        type: 'campo', colVisible: false, dataField: "frazione", dataType: "", caption: "Frazione",
        nCol: 7,
        maxSize: 45,
        maxLength: 45,
        colSpan: '5'
      },


      {
        orderGriglia: 6, showInColumnChooser: true, allowHiding: false,
        type: 'campoSpecial', dataField: "comune", caption: "Comune", dataType: "",
        colVisible: true,
        nCol: 7,
        colWidth: '319',
        disableOnUpdate: false,
        maxSize: 45,
        validation: [
          { type: "required", message: "Comune obbligatorio" },

        ],
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          dataSource: 'comune',
          service: 'comune',
          autocomplete: false,

          searchExpr: {
            valueExpr: 'id',
            dataFields: ['descrizione'],
            related: ['cap', 'siglaProvincia', 'id|istatComune'],
            optionalFilters: {
            },
          },
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          queryString: '?$orderby=Descrizione asc',
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|istatComune'],

          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid: {
            ...gridSimple,
            searchType: 'startsWith',
            colonne: [

              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },

            ]

          }

        }

      },
      {
        orderGriglia: 8,
        type: 'campoSpecial', dataField: "stato", dataType: "", caption: "Stato",
        colVisible: false,
        labelWidth: 50,
        nCol: 3,
        lista: {
          dataSource: 'statoEstero',
          valueExpr: 'iso',
          displayExpr: 'descrizione',
          filter: '?nomeTabella=sedi',
          static: false

        },
        validation: [
          { type: "required", message: "Stato obbligatorio" },

        ],
        editorType: 'dxSelectBox'
      },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },

      {
        type: 'campo', dataField: "cap", dataType: "", caption: "CAP",
        colVisible: true,
        nCol: 3,
        orderGriglia: 7,
        colWidth: '52',
        width: 35,
        maxLength: 5,
        validation: [
          { type: "required", message: "CAP obbligatorio" },

        ],
      },
      {
        orderGriglia: 8, showInColumnChooser: true, allowHiding: false,
        type: 'campoSpecial', dataField: "siglaProvincia", dataType: "", caption: "Provincia",
        colVisible: true,
        nCol: 4,

        editorType: 'dxSelectBox',
        colWidth: '145',
        maxSize: 5,
        labelWidth: 66,
        lista: {
          dataSource: 'provincia',
          displayExpr: 'descrizione',
          valueExpr: 'siglaProvincia',
          static: false,

        },
        validation: [
          { type: "required", message: "Provincia obbligatoria" },

        ],
      },
      {
        type: 'campo',
        colVisible: false,
        showInColumnChooser: false,
        dataField: "istatComune",
        dataType: "",
        caption: "istat",
        nCol: 2,
        labelWidth: 50,
        showClearButton: false,
        disableOnUpdate: true
      },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "", nCol: 1 },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", caption: "" },
      {
        showInColumnChooser: false, orderGriglia: 6,
        type: 'campoSpecial', dataField: "idCategoria", dataType: "", caption: "Categoria",
        colVisible: false,
        disableOnUpdate: true,
        labelVisible: true,
        nCol: 7,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'sedi' }],
          dataSource: 'categoria',
          service: 'generic',
          autocomplete: false,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          caption: "Lista Categorie",
          queryString: '?nomeTabella=sedi',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Categorie',
            name: 'Categorie',
            location: 'after',
          },
          settingGrid: gridEditable

        }
      },
      {
        showInColumnChooser: false,
        type: 'campo',
        colVisible: false,
        visible: false,
        dataField: "riferimentoEsterno",
        dataType: "",
        labelWidth: 50,
        caption: "Rif.Esterno",
        maxLength: "20",
        nCol: 3,
      },
      { type: 'empty', colVisible: false, dataField: "", dataType: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "" },

      {
        showInColumnChooser: false, colVisible: false,
        type: 'campoSpecial', dataField: "idZona", dataType: "", caption: "Zona",
        labelVisible: true,
        disableOnUpdate: true,
        nCol: 4,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'sedi' }],
          dataSource: 'zona',
          service: 'generic',
          autocomplete: false,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          caption: "Lista Zone",
          queryString: '?nomeTabella=sedi',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Zone',
            name: 'Zone',
            location: 'after',
          },
          settingGrid: gridEditable

        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "tipoPCE",
        caption: "Tipo Azienda", maxLength: "1", maxSize: 2, hideOnEdit: false,
        editorType: 'dxSelectBox',
        nCol: 3,
        lista: {
          dataSource: 'tipoPCE',
          valueExpr: 'id',
          displayExpr: 'descrizione',

          static: true

        },
      },
      {
        showInColumnChooser: false,
        type: 'campoSpecial', dataField: "idTipo", dataType: "", caption: "Tipo",
        nCol: 3,
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,
        labelWidth: 50,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'sedi' }],
          dataSource: 'tipo',
          service: 'generic',
          autocomplete: false,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          caption: "Tipo",
          queryString: '?nomeTabella=sedi&',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Tipo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Tipo',
            name: 'Tipo',
            location: 'after',
          },
          settingGrid: gridEditable


        }
      },
      { type: 'empty', colVisible: false, dataField: "", dataType: "" },
      { type: 'empty', colVisible: false, dataField: "", dataType: "" },
      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        dataField: "isImpiantoMobile",
        dataType: "boolean",
        caption: "Cantiere Mobile",
        editorType: "dxCheckBox",
        nCol: 2,
        colVisible: false,
        checkBox: {
          event: {
            type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
            key: 'setTrueImpiantoMobile',
            value: [
              /*{
                optionName: 'isSmaltitore',
                value: 'true'
              }*/
            ]
          }
        }
      },


      {
        showInColumnChooser: false,
        type: 'campoData', dataField: "dataChiusuraImpiantoMobile", caption: "Data Chiusura ", format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        disableOnUpdate: true,
        nCol: 3,
        colVisible: false,
        maxLength: '14',
        colWidth: '150',
        showClearButton: true,
        disabled: true
      },
      {
        showInColumnChooser: false,
        type: 'campo',
        colVisible: false,
        dataField: "superficiePubblica",
        dataType: "boolean",
        labelWidth: 135,
        caption: "Sup. pubblica",
        editorType: 'dxCheckBox',
        nCol: 2,
      },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", },
      { type: 'empty', colVisible: false, dataField: "", dataType: "", },

      {
        showInColumnChooser: false,
        type: 'campo', dataField: "nota", dataType: "", caption: "Note",
        colVisible: false, height: '32px',
        maxLength: "255",
        nCol: 10,
        maxSize: 255,
        editorType: 'dxTextArea'
      },
    ]
  },

  {
    itemType: "group", groupDataField: 'datiMud', groupWidth: 750, caption: "Dati MUD", colCount: "3", colSpan: "1", data: [
      { type: 'empty', colVisible: false, dataField: '', caption: " ", colSpan: 3 },
      {
        showInColumnChooser: false,
        type: 'campoSpecial', colVisible: false, dataField: "elaboraMud", editorType: "dxSelectBox",
        caption: "Elabora MUD",
        nCol: 3,
        colSpan: 3,
        maxSize: 1,
        maxLength: "1",

        lista: {
          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }
      },

      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        colVisible: false,
        dataField: "tipoMud",
        dataType: "", caption: "Tipo Mud",
        colSpan: 3,
        nCol: 6,
        editorType: "dxSelectBox",
        maxLength: "4",
        maxSize: 1,

        lista: {
          dataSource: 'tipoMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }

      },

      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "cciiaa", dataType: "", caption: "C.C.I.A.A di",
        colSpan: 3,
        nCol: 6,
        maxLength: "35",
        maxSize: 35
      },



      {
        showInColumnChooser: false,
        type: 'campoSpecial', colVisible: false, dataField: "ateco", dataType: "", caption: "Ateco",
        nCol: 3,
        maxLength: "10",
        maxSize: 10,
        dynamic: {
          dataSource: 'ateco',
          autocomplete: false,
          service: 'generic',
          valueExpr: '',
          displayExpr: 'id',
          caption: "Elenco Ateco",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Codici Ateco',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista Ateco',
            name: 'ateco',
            location: 'after',
          },
          settingGrid: gridSimple

        }
      },
      {
        showInColumnChooser: false,
        type: 'campo',
        colVisible: false,
        dataField: "rea",
        dataType: "",
        caption: "N.Rea",
        nCol: 3,
        class: 'mesi-attivita',
        editorType: 'dxTextBox',
        maxLength: "11",
        patterns: "^[A-Za-z]{2}\\d+$",
        helpText: 'Le prime due lettere indicano la provincia e altre 9 in mumero Rea',
        labelWidth: 100,
        showClearButton: false,
        uppercase: true
      },
      { type: 'empty', colVisible: false, dataField: '', caption: "" },


      {
        type: 'campo',
        dataType: "",
        editorType: 'dxNumberBox',
        caption: "N. Addetti",

        showInColumnChooser: false,
        colVisible: false,
        dataField: "addetti",
        maxLength: "5",
        maxSize: 10,
        nCol: 3,
      },
      {
        type: 'campo',
        showInColumnChooser: false,
        colVisible: false,
        dataField: "mesiAttivita",
        dataType: "number",
        caption: "Mesi Attività",
        maxLength: "2",
        maxSize: 12,
        editorType: 'dxNumberBox',
        nCol: 3,
        labelWidth: 120,
        // validation: [
        //   { type: "max", message: "Il campo Mesi Attività può arrivare massimo fino a 12", value: 12 },
        //   { type: "min", message: "Il campo Mesi Attività può arrivare minimo fino a 1", value: 1 },
        // ]
      },
      { type: 'empty', colVisible: false, dataField: '', caption: "", nCol: 5 },

      { type: 'empty', colVisible: false, dataField: '', caption: "Legale Rappresentante", colSpan: 3 },
      {
        showInColumnChooser: false,
        type: 'campo',
        colVisible: false,
        dataField: "rappresentanteNome",
        dataType: "", caption: "Nome",
        colSpan: 3,
        nCol: 6,
        maxLength: "30",
        maxSize: 30
      },


      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "rappresentanteCognome", dataType: "", caption: "Cognome",
        colSpan: 3,
        nCol: 6,
        maxLength: "30",
        maxSize: 30
      },


    ]
  },

  {
    itemType: "group", groupWidth: 750, groupDataField: 'altreConfUl', caption: "Altre Configurazioni ", disabled: false, colCount: 1, data: [


      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "Attività svolta ai sensi del D.Lgs 209/2003 (veicoli fuori uso)", colSpan: '2', class: 'nsAziendaTrue' },


      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false,
        dataField: "autodemolizione",
        dataType: "boolean",
        caption: "Autodemolizione di veicoli fuori uso",
        maxLength: "1",
        maxSize: 1,
        editorType: 'dxCheckBox',
        nCol: 10,
        labelWidth: 230,
      },
      {
        showInColumnChooser: false,
        type: 'campo',
        colVisible: false,
        dataField: "rottamazione",
        dataType: "boolean",
        caption: "Rottamazione di veicoli fuori uso",
        labelWidth: 230,
        maxLength: "1",
        maxSize: 1,
        colSpan: "2",
        editorType: 'dxCheckBox',
        nCol: 10,
      },
      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "frantumazione", dataType: "boolean", caption: "Frantumazione di veicoli fuori uso",
        labelWidth: 230,
        maxLength: "1",
        maxSize: 1,
        colSpan: "2",
        editorType: 'dxCheckBox',
        nCol: 10,
      },
      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "Altre Attività", colSpan: '2', class: 'nsAziendaTrue' },

      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "gestioneRaee", dataType: "boolean", caption: "Gestione RAEE", helpText: "",
        nCol: 10,
        maxLength: "1",
        maxSize: 1,
        labelWidth: 230,
        editorType: 'dxCheckBox',
      },
      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "gestioneImballaggi", dataType: "boolean", caption: "Gestione imballaggi",
        labelWidth: 230,
        maxLength: "1",
        maxSize: 1,
        editorType: 'dxCheckBox',
        nCol: 10,
      },


      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "CONOU & COBAT" },


      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "codiceConou", dataType: "", caption: "Codice CONOU",

        maxLength: '10',
        nCol: 3
      },


      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "isCobat", dataType: "", caption: "Iscritto Cobat",


        editorType: 'dxCheckBox',

      },


    ],
  },
  /*{
    itemType: "group", caption: "Allineamento R.E.N.T.R.i ", groupDataField:'allineamentoReentri', disabled: false, colCount: "2", data: [

      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "SEDE R.E.N.T.R.i & Registro Predefinito", colSpan: '2', class: 'nsAziendaTrue' },

      {
        type: 'campoButton', 
        showInColumnChooser: false, 
        colVisible: false, 
        dataField: "idSedeRentri",
        dataType: "",
        caption: "Sede R.E.N.T.Ri",
        class: 'nsAziendaTrue',
        colSpan: '2',
        disableOnUpdate:true,
        nCol:3,
        button: {
          name: 'allineaRentri',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "ottieni le sedi R.E.N.T.R.i",
          icon: "glyphicon mdi mdi-playlist-plus",
          outPutValue: false,
        }
      },
    ]
  },*/
  {
    itemType: "group", groupWidth: 750, caption: 'Coordinate Geografiche', colCount: '2', data: [
      { type: 'empty', colVisible: false, dataField: '', caption: " ", colSpan: 2 },
      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "latidudine", dataType: "number", caption: "Latitudine",
        nCol: 9,
        colSpan: 2,
        maxSize: 30,
        maxLength: '30',
        helpText: '(Specificare un numero compreso tra -90 e 90)'
      },


      {
        showInColumnChooser: false,
        type: 'campo', colVisible: false, dataField: "longitudine", dataType: "number", caption: "Longitudine",
        nCol: 9,
        colSpan: 2,
        maxSize: 30,
        maxLength: '30',
        helpText: '(Specificare un numero compreso tra -180 e 180)'
      },

      { type: 'empty', colVisible: false, dataField: '', nCol: 7 },

      {
        type: 'simpleButton',
        dataField: "buttonCoordinate",
        colVisible: false,
        nCol: 3,
        button: {
          text: 'Ottieni Coordinate',
          name: "ottieniCoordinate",
          event: "coordinateGeografiche",
          type: "normal",
          hint: "ottieni le coordinate",
          icon: "mdi mdi-google-maps",
          class: 'blueButton',

          related: ['latidudine', 'longitudine'],

        }
      },



    ]
  },


]


